<template>
  <nav v-if="config.nav.length" class="c-nav-desktop__nav" :aria-label="config.primaryNavAriaLabel">
    <!-- First level -->
    <ul class="c-nav-desktop__primary-nav-list" role="list">
      <li
        class="c-nav-desktop__primary-nav-item"
        v-for="(firstLevelItem, firstLevelNumber) in config.nav"
        :key="`first-level-${firstLevelNumber}`"
        ref="meganavFirstLevelRef"
        role="listitem"
      >
        <desktopNavItem
          :activeFirstLevelNumber="activeFirstLevelNumber"
          :firstLevelItem="firstLevelItem"
          :firstLevelNumber="firstLevelNumber"
          @primaryLevelButtonClick="primaryLevelButtonClick"
          @closeMeganav="closeMeganav"
        />
      </li>
    </ul>
  </nav>
</template>
<script setup>
import { inject, ref, onMounted, nextTick } from 'vue';
import desktopNavItem from '@/app/components/nav-desktop-inner.vue';
const config = inject('config');

const activeFirstLevelNumber = ref(null);
const meganavFirstLevelRef = ref(null);

const mediaQuery = window.matchMedia('(min-width: 61.25em)');

const activeBodyOverlayClass = 'is-menu';
const selectorsToBeInertOnOpenNav = document.querySelectorAll('main, footer, .js-vue-inert');

function primaryLevelButtonClick(i) {
  i === activeFirstLevelNumber.value ? closeMeganav() : openMeganav(i);
}

function clickOutside(e) {
  const activeInner = [...meganavFirstLevelRef.value][activeFirstLevelNumber.value];
  nextTick(() => {
    if (!activeInner) {
      return;
    }

    if (!activeInner.contains(e.target)) {
      closeMeganav();
    }
  });
}

function handleEscape(e) {
  if (e.key === 'Escape' && activeFirstLevelNumber.value !== null) {
    e.preventDefault();
    closeMeganav();
  }
}

function openMeganav(i) {
  activeFirstLevelNumber.value = i;
  selectorsToBeInertOnOpenNav.forEach((el) => el.setAttribute('inert', ''));
  document.body.classList.add(activeBodyOverlayClass);

  window.addEventListener('click', clickOutside);
  window.addEventListener('keydown', handleEscape);
}

function closeMeganav() {
  activeFirstLevelNumber.value = null;
  selectorsToBeInertOnOpenNav.forEach((el) => el.removeAttribute('inert'));
  document.body.classList.remove(activeBodyOverlayClass);

  window.removeEventListener('click', clickOutside);
  window.removeEventListener('keydown', handleEscape);
}

onMounted(() => {
  mediaQuery.addEventListener('change', () => {
    closeMeganav();
  });
});
</script>
